export default function PageHero({ eyebrow, title, description, children }) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#FFF7EE] to-[#FAF8F5] border-b border-slate-200">
      <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#FF7F00]/10 blur-3xl" />
      <div className="relative max-w-5xl mx-auto px-6 sm:px-10 py-20 sm:py-28">
        {eyebrow && (
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#FF7F00]">
            {eyebrow}
          </p>
        )}
        <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.05]">
          {title}
        </h1>
        {description && (
          <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-2xl">
            {description}
          </p>
        )}
        {children}
      </div>
    </section>
  );
}
